import { AppRouter } from 'src/router/AppRouter'


function App() {
    return (<AppRouter/>);
}

export default App;